export class SpinButtonEvents {
    public static readonly SPIN_BUTTON_PRESSED: symbol = Symbol('SPIN_BUTTON_PRESSED');
    public static readonly SPIN_BUTTON_HOLD: symbol = Symbol('SPIN_BUTTON_HOLD');

    public static readonly ENABLE: symbol = Symbol('ENABLE');
    public static readonly DISABLE: symbol = Symbol('DISABLE');
}